import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
The main entry point for the Search.
Referenced by the search.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/templates/search.scss';
import { CheckListPalette } from './components/CollectionFilters/FiltersMobile';
import { getPalettes } from './apps/collection/queries';
import { JSON_HEADERS } from './config/constants';
import OVApp from './utils/OVContext';
import rtrim from './utils/strings/rtrim';
import SearchNoResults from './components/SearchNoResults';
import SearchResults from './components/SearchResults';
import SelectPalette from './components/SelectPalette';
import RecommendationsAI from './components/RecommendationsAI';
import { jsx as _jsx } from "react/jsx-runtime";
var SEARCH_PERFORMED = window.OV.SEARCH_PERFORMED;
var urlParams = new URLSearchParams(window.location.search);
var searchTerms = urlParams.get('q');

var renderResults = function renderResults(filters, results, popularSearches) {
  if (results.length < 1) {
    ReactDOM.render( /*#__PURE__*/_jsx(SearchNoResults, {
      popularSearches: popularSearches
    }), document.getElementById('search-results'));
    return;
  }

  document.querySelector('.search__form__input').value = searchTerms;
  var men = 'Men';
  var terms = searchTerms ? searchTerms.toLowerCase().split(' ') : [];
  var women = 'Women';
  var filts = [];

  if (filters.palettes) {
    var filterByColor = false;
    var paletteIds = filters.palette_ids; // try to match up the search terms with the palette colors

    terms.forEach(function (term) {
      filterByColor = filterByColor || filters.palettes.find(function (palette) {
        return term.length > 2 && palette.title.toLowerCase() === term.toLowerCase();
      });
    });

    if (filterByColor) {
      filterByColor = {
        label: filterByColor,
        value: filterByColor.id
      };
    }

    filts.push({
      component: SelectPalette,
      componentMobile: CheckListPalette,
      filter: function filter(product, value) {
        return product.palette_ids.includes(value);
      },
      label: 'Color',
      options: paletteIds.map(function (pal) {
        return {
          value: pal
        };
      }),
      query: getPalettes,
      selected: filterByColor,
      swatches: true,
      value: '',
      variables: {
        ids: paletteIds
      }
    });
  }

  if (filters.genders) {
    var filterByGender = false;
    terms.forEach(function (term) {
      filterByGender = filterByGender || (term.startsWith('men') || term.startsWith('man') ? {
        label: men,
        value: men
      } : false) || (term.startsWith('women') || term.startsWith('woman') ? {
        label: women,
        value: women
      } : false);
    });
    filts.push({
      label: 'Gender',
      filter: function filter(_ref, value) {
        var gender = _ref.gender;
        return gender === 'None' || gender === 'Unisex' || gender === value;
      },
      selected: filterByGender,
      value: filterByGender || '',
      options: [{
        ariaLabel: 'Filter Search Results by Women',
        label: women,
        value: women
      }, {
        ariaLabel: 'Filter Search Results by Men',
        label: men,
        value: men
      }]
    });
  }

  if (filters.categories) {
    var filterByCategory = false; // try to match up the search terms with the categories

    terms.forEach(function (term) {
      filterByCategory = filterByCategory || filters.categories.find(function (category) {
        return term.length > 2 && rtrim(category.toLowerCase(), ['s']) === rtrim(term, ['s']);
      });
    });

    if (filterByCategory) {
      filterByCategory = {
        label: filterByCategory,
        value: filterByCategory
      };
    }

    filts.push({
      label: 'Category',
      filter: function filter(_ref2, value) {
        var category = _ref2.category;
        return category === value;
      },
      selected: filterByCategory,
      value: '',
      options: filters.categories.map(function (filt) {
        return {
          ariaLabel: "Filter Search Results By ".concat(filt),
          label: filt,
          value: filt
        };
      })
    });
  }

  var prices = _toConsumableArray(new Set(results.map(function (result) {
    return result.price;
  })));

  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(SearchResults, {
      displaySort: prices.length > 1,
      results: results,
      filters: filts,
      searchTerms: searchTerms
    })
  }), document.getElementById('search-results'));
};

var loadResults = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var request, response, filters, results, popularSearches, redirect;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("https://search.outdoorvoices.com/search/?q=".concat(searchTerms), JSON_HEADERS);

          case 3:
            request = _context.sent;
            _context.next = 6;
            return request.json();

          case 6:
            response = _context.sent;
            filters = response.filters, results = response.results, popularSearches = response.popular_searches, redirect = response.redirect;

            if (!(redirect !== undefined)) {
              _context.next = 11;
              break;
            }

            window.location.assign(redirect);
            return _context.abrupt("return");

          case 11:
            renderResults(filters, results, popularSearches);
            _context.next = 19;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            console.error('error', _context.t0);
            document.getElementById('search-results').style.display = 'none';
            document.getElementById('hidden-search-results').style.display = 'block';

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function loadResults() {
    return _ref3.apply(this, arguments);
  };
}();

ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
  children: /*#__PURE__*/_jsx(RecommendationsAI, {
    id: "UmVjb21tZW5kYXRpb25BSU5vZGU6Mw==",
    title: "Recommended For You"
  })
}), document.getElementById('alt-promo'));

if (SEARCH_PERFORMED) {
  loadResults();
}